<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Наши клиенты"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="bannersData"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Добавление клиента</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Имя"
                      />
                      <v-text-field
                        v-model="editedItem.info"
                        label="Описание"
                      />
                      <v-select
                        v-model="editedItem.status"
                        :items="statusList"
                        label="Статус"
                        single-line
                      />
                      <v-card>
                        <v-card-title>Сопутствующие товары</v-card-title>
                        <v-card-text>
                          <relations :open-dialog="dialog" :default="editedItem.offers" @change="val => editedItem.offers = val" />
                        </v-card-text>
                      </v-card>
                      <file-input :value="editedItem.images" bucket="image" @change="setImage" />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-dialog
              transition="dialog-bottom-transition"
              width="500"
              :value="deleteDialog === item.id"
              @input="toggleDeleteDialog($event, item.id)"
            >
              <template #activator="{ on, attrs }">
                <v-tooltip top>
                  <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                    <span v-bind="tooltipAttrs" v-on="tooltipActions">
                      <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                        mdi-delete
                      </v-icon>
                    </span>
                  </template>
                  Удалить
                </v-tooltip>
              </template>
              <v-card>
                <v-toolbar color="primary" dark class="text-center mb-6">
                  Подтвердите Действие
                </v-toolbar>
                <v-card-text>
                  Вы точно хотите удалить страницу "{{ getDescriptionForList(item) }}"?
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="tertiary" dark @click="deleteDialog = null">
                    Отменить
                  </v-btn>
                  <v-btn color="primary" @click="deleteItem(item.id)">
                    Удалить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template #item.image="{ item }">
          <v-img
            width="200px"
            height="200px"
            contain
            :src="`${getImage(item)}`"
          />
        </template>
        <template #item.name="{ item }">
          <p> {{ getNameForList(item) }} </p>
        </template>
        <template #item.description="{ item }">
          <p> {{ getDescriptionForList(item) }} </p>
        </template>
        <template #item.status="{ item }">
          <p>{{ getStatus(item) }}</p>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { addBannerItem, banner_area, updateBannerItem } from '@/graphql/banners'
import { has, startCase } from 'lodash-es'
import Relations from '@/components/press/relations'
import FileInput from '~/components/press/FileInput'

export default {
  name: 'Banners',
  components: {
    FileInput,
    Relations
  },
  layout: 'dashboard',
  apollo: {
    banner_area: {
      query: banner_area,
      variables () {
        return this.getBannersQueryVariables()
      },
      update (data) {
        return data.bannerArea.items.data
      },
      result ({ data }) {
        this.totalCount = data.bannerArea.items.totalCount
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      selectedCategory: null,
      deleteDialog: false,
      dialog: false,
      newItem: true,
      parentSlug: 'clients',
      editedItem: {},
      statusList: [
        { value: 'PUBLISHED', text: 'Активно' },
        { value: 'DRAFT', text: 'Не активно' }
        // { value: 'DELETED', text: 'Удалено' }
      ],
      statusListConverter: { 1: 'PUBLISHED', 0: 'DRAFT', '-1': 'DELETED' },
      headers: [
        ['id', 'Id'],
        ['image', 'Картинка'],
        ['name', 'Имя'],
        ['description', 'Описание'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
    bannersData () {
      return this.banner_area ?? []
    }
  },
  watch: {
    selectedCategory () {
      this.options.page = 1
    },
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getDescriptionForList (item) {
      return item.description.length > 1 ? item.description[1] : ''
    },
    getNameForList (item) {
      return item.description.length > 0 ? item.description[0] : ''
    },
    getBannersQueryVariables () {
      return {
        slug: this.parentSlug,
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1)
      }
    },
    setImage (images) {
      this.editedItem.images = images
    },
    getImage (item) {
      if (item.images != null && item.images.length > 0) {
        return item.images[0].file?.url
      } else {
        return ''
      }
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      if (item.images.length > 0) {
        this.editedItem.clickUrl = item.images[0].clickUrl
      }
      if (has(this.statusListConverter, item.status)) {
        this.editedItem.status = this.statusListConverter[item.status]
      }
      this.editedItem.name = this.getNameForList(item)
      this.editedItem.info = this.getDescriptionForList(item)
      this.dialog = true
    },
    save () {
      this.editedItem.areaSlug = this.parentSlug
      this.editedItem.position = parseInt(this.editedItem.position)
      let newImages = []
      if (this.editedItem.images?.length > 0) {
        newImages = this.editedItem.images.map(item => ({ key: item.file.key, alt: item.alt, clickUrl: this.editedItem.clickUrl }))
      }
      this.editedItem.description = [this.editedItem.name, this.editedItem.info]
      let offers = []
      if (typeof this.editedItem.offers !== 'undefined') {
        offers = this.editedItem.offers.map(val => val.toString())
      }
      if (this.newItem) {
        this.$apollo
            .mutate({
              mutation: addBannerItem,
              variables: {
                input: {
                  description: this.editedItem.description,
                  areaSlug: this.editedItem.areaSlug,
                  status: this.editedItem.status,
                  offers,
                  images: newImages
                }
              }
            })
            .then((data) => {
              this.$apollo.queries.banner_area.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      } else {
        const id = this.editedItem.id
        this.$apollo
            .mutate({
              mutation: updateBannerItem,
              variables: {
                id,
                input: {
                  description: this.editedItem.description,
                  areaSlug: this.editedItem.areaSlug,
                  status: this.editedItem.status,
                  offers,
                  images: newImages
                }
              }
            })
            .then((data) => {
              this.$apollo.queries.banner_area.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      }
      this.editedItem = []
      this.close()
    },
    close () {
      this.editedItem = []
      this.dialog = false
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: updateBannerItem,
            variables: {
              id,
              input: {
                areaSlug: this.parentSlug,
                status: 'DELETED'
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.banner_area.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    getStatus (item) {
      if (has(this.statusListConverter, item.status)) {
        const ret = this.statusList.filter(row => row.value === this.statusListConverter[item.status])
        if (ret.length > 0) {
          return ret[0].text
        }
      }

      return item.status
    }
  }
}
</script>

<style scoped>

</style>
